module.exports = __webpack_public_path__ + "img/remove.538154ae.svg";